export function createTokenRefreshHandler({ setToken, restartAuthentication }) {
  return async function applyRotatedToken(token) {
    await setToken(token);
    await restartAuthentication();
  };
}
